module.exports = __webpack_public_path__ + "img/device_1012_1.f0647960.svg";